import { ReportChartConfiguration } from '@vision/ui/interfaces';
import { BarChart4CompareRenderer } from '../../../components';
import {
  DefaultReportChartThemeFont,
  DefaultReportChartThemeSeries,
  extendDefaultChartValidationSchema,
} from '../../default-chart.config';
import { ExBarChart4Measures } from './ex-bar-chart4.measures';

export const ExBarChart4DefaultConfiguration: ReportChartConfiguration = {
  validationSchema: extendDefaultChartValidationSchema({}),
  measures: ExBarChart4Measures,
  compareRendererComponent: BarChart4CompareRenderer,
  compareMultiple: true,
  customize: {
    active: (values) => values.selectedMeasure && values.selectedCompare.length > 0,
    transactionalDate: {
      active: false,
    },
    sortResults: {
      limit: 0,
      order: null,
    },
    limits: {
      upperLimitActive: false,
      upperLimit: 0,
      lowerLimitActive: false,
      lowerLimit: 0,
    },
  },
  defaultTheme: {
    active: (values) => values.selectedMeasure && values.selectedCompare.length > 0,
    title: {
      ...DefaultReportChartThemeFont,
      label: '',
    },
    xAxis: {
      ...DefaultReportChartThemeFont,
    },
    yAxis: {
      ...DefaultReportChartThemeFont,
      activeDisplayFormat: false,
    },
    dataLabels: {
      ...DefaultReportChartThemeFont,
      active: false,
      alignment: 'horizontal',
      displayFormat: 'auto',
      labelDisplayFormat: 'number',
      position: 'top',
    },
    series: {
      ...DefaultReportChartThemeSeries,
    },
  },
};
